<template>
    <div style="background:white" class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1417', '采购送货-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1416', '采购送货-明细') }}</div>
            </div>
        </div>        
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <item-two></item-two>
        </div>  
        <div v-show="actitem=='one'" style=" display:flex; width:100%;min-width:1300px; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">
            <div style="line-height:30px;margin-left:3px;margin-right:4px;font-size:12px">{{ $LANG('0298', '字段') }}</div>
            <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:130px; ">
                <span v-for="item in tabArr" :key='item.key' >
                    <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <div style="margin-left:15px;display:flex;align-items:center;flex-shrink:0;line-height:30px;">
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin-right:4px"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false">
                    <span style="font-size:12px">{{ $LANG('0683', '字段设置') }}</span>
                </el-link>
            </div>
        </div> 
        <div v-show="actitem=='one'" class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="tabData"
            :columnHiddenOption="columnHiddenOption"
            :footer-data="[]"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :event-custom-option="eventCustomOption"
            :max-height="tabHeight"
            :virtual-scroll-option="virtualScrollOption"
            :column-width-resize-option="columnWidthResizeOption"
            :cellSelectionOption="{enable: false}"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            v-loading="loading"
            :element-loading-text="$LANG('2030', '数据加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="po_send_main_table"
            ref="tabref">
        </ve-table>
        </div>
        <div v-show="actitem=='one'" style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:86vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-div">
                        <span class="oneRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  >  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem   :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <template slot="label" ><span v-if="item.key=='SHPDTTM'" style="color:red;margin-right:8px">*</span>{{ $translate.getColTitle(item, $store.state.lang) }}</template>
                                <el-date-picker size="medium" :disabled="saveFlag||item.DISABLED==='Y'?true:false" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border disabled v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-div">
                    <span class="oneRow">{{ $LANG('0992', '送货明细') }}</span>
                </div>
                <el-table  :data="dtlData" 
                    border       
                    class="custom-table-border"                     
                    size="small"
                    ref="refdtl"
                    show-summary
                    v-loading="v_loading"
                    :element-loading-text="$LANG('2030', '数据加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(100, 100, 100, 0.8)"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    style="margin-top:-8px"
                    :summary-method="getMatSum"
                    :height="350" 
                    highlight-current-row >  
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.key!=='RN'"
                        :min-width="item.width">
                        <template slot="header">{{item.title}}<span v-if="item.notnull=='Y'" style="color:red">*</span></template>
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <span v-else  >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="80">
                        <template slot-scope="scope"> 
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                            <el-link :disabled="saveFlag"  @click="dtlEdit(scope.row,scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:2px;">{{ $LANG('1639', '编辑') }}</span> </el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="one-div"><span class="oneRow"> 附件明细【 上传PDF或图片文件】</span></div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','gif','tiff' ,'pdf']"
                        :max-size="10240"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:160px; ">                           
                        <div style="padding: 1px 0;width:160px;height:120px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:20px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-right:30px;flex-wrap:wrap"  >
                        <div v-for="(item,index) in imgData" :key="index" style="margin-left:10px">  
                            <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:160px;height:120px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"  fit="scale-down" v-else   style="width:160px;height:120px;margin-right:30px;" :src="item.FILEPATH"/> 
                            <div style="width:160px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                <span style="font-weight:600;font-size:12px;color:red">{{ $LANG('0473', '文件名') }}：</span>{{item.FILENM}}
                            </div>
                            <div style="height:25px;background:#e8eaec;width:160px; display:flex;justify-content:space-between">
                                <el-link  :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="saveRec" :disabled="saveFlag" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  >{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
  
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
      
 
        <!-- 明细资料框 -->
        <el-dialog v-dialogDrag  :visible.sync="dtlWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0921', '编辑记录') }}</span>
            </div>
            <Form :model="dtlRow" :label-width="120"  label-position="right" inline  >  
                <span v-for="(item,index) in dtlCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number controls-position="right" :precision="item.dotnum" :disabled="item.disabled==='Y'?true:false||saveFlag"  v-else-if="item.edcss==='number'" v-model="dtlRow[item.key]" style="width:100%" ></el-input-number>   
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form> 
            <span slot="footer"  >
                <el-button type="info" @click="dtlWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                <el-button @click="dtlSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  >{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 送货明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="poWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1167', '下推送货明细') }}</span>
            </div> 
            <div style="height:86vh;overflow-y:auto">
            <div class="one-toolbar">
                <span class="spanRow"  ></span> 
                <el-checkbox @change="selEvent" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:white">{{ $LANG('0263', '全选') }}</span></el-checkbox>
                <span style="margin-left:6px">{{ $LANG('0298', '字段') }}</span>
                <el-select v-model="selparam4"  :placeholder="$LANG('1675', '请选择列名')"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in stkCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryDtl" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryDtl" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextCate" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">{{ $LANG('1168', '下推选择记录') }}</el-button>
            </div>
            
            <el-table  :data="dtlData.filter(item=>item.ISNEXT=='N')" 
                border                            
                size="small"
                class="custom-table-border"
                :row-key="getDtlKey"
                :cell-style="{padding:'2px'}"
                :height="400" 
                cell-class-name="clearPadding"
                highlight-current-row > 
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-input type="number"  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='CHKQTY' "  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input>
                        <el-input v-else-if="item.key=='STKRMK'" :disabled="item.disabled=='Y'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
            </el-table>
            <el-table  :data="nextData" 
                border                            
                size="small"
                ref="refreq"
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                :row-key="getDtlKey"
                :height="maxHeight" 
                highlight-current-row >               
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    :label="$LANG('0330', '操作')"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"  type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="poWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="genQa" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >{{ $LANG('1118', '生成质检单') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate ,getDate2} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue'  
import itemTwo from './po_send_two.vue'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"po_send_notice",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '401217',
            fieldIdseq: '401217',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            columnHiddenOptionKey: 'columnHiddenOption',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            poWin:false,
            v_dttm:'',
            v_rmk:'',
            stkData:[],
            repDlg:false,
            selAll:'N',
            allSel:'N',
            allNext:'N',
            isSame:'N',
            v_stkqty:'',
            v_stkrmk:'',
            v_poqty:'',
            v_poprc:'',
            v_rate:'',
            nextData:[],
            v_idseq:'',
            loading:false,
            v_selAll:'N',
            repWin:false,
            repUrl:'',
            stkCol:[],
            addWin:false,
            dtlRow:{},
            saveFlag:false,
            promptWin:false,
            prompt:'',   
            mainRow:{},
            input_hold:this.$LANG('1718', '请输入查询的值'),
            dtlWin:false,
            active:'',  
 
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            v_loading:false,
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
            },
            dtlData:[], //明细数据
            dtlCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
            actitem:'one',
            txtparam3:'',
            selparam3:'',
            txtparam4:'',
            selparam4:'',
            oper4:'like',
            delArr:[],
            repArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            v_replist:[],
            v_idno:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_rowIndex:'',
            delImg:[],
            stfgNm:'',
            v_row:{},
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
            v_index:'',
            v_tabindex:'',
            v_tabrow:{},
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            imgData:[],
            maxHeight:'',
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                // column size change
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "jpg,jpeg,png,gif,tiff,pdf", //上传文件格式限制
            v_oth:'N',
        }
    },
    mounted () { 
        this.maxHeight = document.documentElement.clientHeight - 170
         
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //表单所以下拦框动态赋值
        this.comSelect()
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','401217','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','401217','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 340) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    components: {
        repWin,
        itemTwo,
        VeColumnConfigDialog,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.initPriv()
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        itemClick(val){
            this.actitem =val     
        },
        pdfShow(filepath){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:filepath},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})   
        },
        //查询图片数据
        qryImgData(idseq){
            this.imgData =[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择正确的图片格式 ')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + this.$LANG('1561', '文件太大， 不能超出') + '10M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
 
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            }else if (res.code=='201'){ // 文件哈希值存在的情况下
                this.imgData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})                   
            }else{
                this.promptWin =true
                this.prompt =res.result
            }
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {       
            this.fileName= getDate('year')+'-RCV'     
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        rowShow(){
            this.v_row ={}
            this.current =1
            this.qryTabData()
        } ,
        sortHeaderColumn(column, edcss){
            const key =column.key
            if (!key) return
            if (this.headerSortKey === key) {
                this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            }else{
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            const direction =this.headerSortOrder === 'asc' ? 1 : -1
            const type =String(edcss || '').toLowerCase()
            this.tabData.sort((left, right) => {
                const leftValue =left[key]
                const rightValue =right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        initPriv(){
            //用户表单新增、编辑、审核、作废权限 :frmid:  ID
            getBaseData(this.v_url,'userno',this.v_username,'frmidseq','401217','v_sys_user_priv','').then(res=>{  
                let row =res.result[0]
                this.v_oth =row['ISOTH']
                this.getOrdList(' and shpdttm>=\''+getDate2(30)+'\'') //获取订单列表
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //下推
                    this.cancelBool=true
                }                  
            }) 
        },
        //下推质检单
        nextGen(row ){
            this.poWin=true
            this.getNextData(row['IDSEQ'])
            this.selAll='N'
            this.nextData=[]
        },
        //生成质检单
        genQa(){
            let v_qtyFlag =false  
 
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt =this.$LANG('1641', '下推记录为空')
            }else{
                this.nextData.some(item=>{
                    if (!item['STKQTY'] ||item['STKQTY']==0 ){
                        v_qtyFlag =true
                    }
                })
                if (v_qtyFlag){
                    this.promptWin =true
                    this.prompt =this.$LANG('0813', '请检查下推记录：收货数量')+'>0'
                }else {
                    this.$confirm(this.$LANG('1605', '你确定要下推生成质检单吗'),this.$LANG('1442', '提示'),{
                        confirmButtonText: this.$LANG('1638', '确定'),
                        cancelButtonText:this.$LANG('0132', '取消'),
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        let v_json =JSON.stringify(this.nextData)
                        let v_action ='QACHK_'+this.v_username+getDate('full')
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/next_genstk',
                            data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                        }).then(res=>{ 
                            if (res.code=='200'){        
                                this.$notify({
                                    title: this.$LANG('1441', '成功'),
                                    message: this.$LANG('1487', '已成功下推质检单，请到送货质检单界面中查看'),
                                    type: 'success'
                                })
                            }else{
                                this.promptWin =true
                                this.prompt =this.$LANG('1446', '下推失败！')+res.result
                            }
                            this.poWin =false
                        })
                    }).catch(()=>{})   
                }             
            }
        },
        nextDel(row,index){
            this.dtlData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        //下推分配
        nextCate(){
            if (this.dtlData.filter(item=>item.SEL=='Y').length >0) {
                this.dtlData.forEach((item,index)=>{
                    if (item.SEL=='Y' &&item['ISNEXT']=='N' ){    
                        let v_okqty =0 ,v_poqty=0,v_stkqty=0  //已质检数 ,采购数，收货数
                        if (item['CHKQTY']){
                            v_okqty =Number(item['CHKQTY'])
                        }
                        if (item['STKQTY']){  //送货数
                            v_stkqty =Number(item['STKQTY'])
                        }
                         if (item['QTY']){  //采购数
                            v_poqty =Number(item['QTY'])
                        }
                        let v_over =Number(v_okqty - v_stkqty )
                        if (v_over>0 ) {
                            this.$confirm(this.$LANG('0547', '产品编码：')+item['MATNO']+this.$LANG('0806', '质检数量已超出送货数量')+v_over+this.$LANG('1571', '，要继续下推吗？'),this.$LANG('1442', '提示'),{
                                confirmButtonText: this.$LANG('1638', '确定'),
                                cancelButtonText:this.$LANG('0132', '取消'),
                                customClass:'messageBox',
                                showClose:false,
                                type:'info',
                            }).then(()=>{
                                this.dtlData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                                this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                            }).catch(err =>{})
                        }else {                          
                            this.dtlData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))                        
                            this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                        }
                    }           
                })
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1684', '请选择记录')
            }
        },
        selEvent(){
            this.dtlData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
        
        dtlSure(){
            if (!this.dtlRow['SHPQTY']){
                this.promptWin=true
                this.prompt=this.$LANG('2067', '送货数量不能为空')
            }else{
                this.dtlWin =false
 
                this.dtlData.splice(this.rowIndex,1,this.dtlRow)
 
            }
        },
        dtlEdit(row,index){
            this.rowIndex =index
            this.dtlRow =JSON.parse(JSON.stringify(row))
            this.dtlWin =true
        },
        //保存记录
        saveRec(){
            var vm =this 
            //发起保存请求   
            if (!this.mainRow['SHPDTTM']) {    
                this.prompt=this.$LANG('2068', '送货日期不能为空')
                this.promptWin =true
            }else {
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(vm.mainRow), p_table:'po_sent',frmid:'401217'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
                        //明细保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'po_sentdtl',p_idseq:res.idseq,p_action:'S' },
                         }) 
                        //3、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                            })
                        }  
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promptWin=true
                                }else{                          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            console.log(res.result)
                                        })
                                    }
                                }        
                            })        
                        }
                        vm.addWin =false   
                        vm.getOrdList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
 
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val=='Y'?this.$LANG('0134', '审核'):val=='N'?this.$LANG('0137', '弃审'):this.$LANG('0131', '删除')
            let v_dttm =val=='Y'? getDate('full') :''
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox', 
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                let v_cond =' set stfg=\''+val+'\',cfmdttm=\''+v_dttm+'\''
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_sent',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()   
                        //审核与弃审时自动生成质检单  
                        const payload = {corpid:this.v_corpid,p_idseq:row['IDSEQ'],p_action:'POSEND_CHK#' ,p_user:this.v_username,p_cond:val}
                        console.log(val,row['IDSEQ'])
                        this.$axios({
                            method: 'post',
                            url:'/xuper_oss/call_package',
                            data: payload,
                        }).then(res=>{
                            if (res.code!=='200'){
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        })
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //下推生成送货通知
        genSend(){
            let v_arr =[]
            this.nextData.forEach(item=>{
                if (item['SEL'] =='Y'){
                    v_arr.push(item)
                }
            })
            if (v_arr.length ==0){
                this.promptWin =true
                this.prompt =this.$LANG('0791', '请勾选要下推的记录')
            }else{
                this.$confirm(this.$LANG('1626', '你确定下推勾选记录生成送货通知单吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                })
            }
        },
        chkChg(row){
            if (!row['SENDQTY'] && row['SEL']=='Y'){
                row['SENDQTY'] =row['POQTY']
            }
        },
 
        getMatSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===1){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='QTY'||column.property==='SHPQTY'  ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(2) 
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //表行点击事件
        rowClick(row){
            this.v_idseq =row['IDSEQ']            
        },
        qryDtl(){
            if (this.v_idseq){
                this.getNextData(this.v_idseq)
            }
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'401217',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //订单明细
        getOrdList(cond){
            //获取所有产品记录且初始化分页记录
            this.loading =true
            const requestId =++this.queryRequestId
            let v_cond ='' 
            if ( this.v_oth=='Y' ){
                v_cond =' and addemp=\'' +this.v_username+'\''
            }
            const orderField =isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO'
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid',p_value:this.v_corpid, p_cond:cond+ v_cond+'  ORDER BY '+orderField+' desc',p_table:'V_po_sent'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result || []
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        const table = this.$refs.tabref
                        if (table && typeof table.doLayout === 'function') table.doLayout()
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt=error.message || this.$LANG('1641', '查询失败')
                this.promptWin=true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.loading=false
            })
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            this.v_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:idseq,p_table:'V_po_sentdtl'},
            }).then(res=>{ 
                this.dtlData =res.result
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                    this.v_loading=false
                })                
            })          
        },
        getNextData(idseq){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:idseq,p_table:'V_po_sentdtl'},
            }).then(res=>{ 
                this.dtlData =res.result               
            })          
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
      
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        selRec(){
           
            this.nextData.forEach((item,index)=>{
                let v_qty =this.v_selAll =='Y'?item['POQTY']:''
                this.nextData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{SEL:this.v_selAll,SENDQTY:v_qty})) ))
            })
            
        },
        editRec(row,val,index){
            this.v_rowIndex =index
            this.saveFlag= val=='Y'?true:false
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.addWin=true  
            this.delImg =[]
            this.getDtlData(row.IDSEQ) 
            this.qryImgData(row['IDSEQ'])  
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            this.headerSortKey =''
            this.headerSortOrder =''
            const toolbarCondition =buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, {
                typeOverrides: { STFG: 'select', ISSTK: 'select' },
                numberOperatorDefault: '>=',
            })
            this.current =1
            this.getOrdList(toolbarCondition+headerCondition)
        },
  
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401217','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result || []
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        const headerSortable =item.key !== 'RN' && item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'
                        vm.tabArr.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            notnull: item.NOTNULL,
                            sortable: item.SORTABLE,
                            fix: item.fix || item.FIX,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            align: item.align,
                            width: Number(item.width) || 120,
                            fixed: item.fix === 'Y' || item.FIX === 'Y' ? 'left' : undefined,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={item.key === 'STFG' || item.key === 'ISSTK' ? 'select' : item.EDCSS}
                                value={this.v_row[item.key]}
                                operator={this.v_row[`#OPER${item.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={headerSortable}
                                sortOrder={this.headerSortKey === item.key ? this.headerSortOrder : ''}
                                options={item.key === 'STFG' || item.key === 'ISSTK' ? [
                                    { value: 'Y', label: this.$LANG('2047', '是') },
                                    { value: 'N', label: this.$LANG('2044', '否') },
                                ] : []}
                                on-input={(value) => this.$set(this.v_row, item.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${item.key}`, value)}
                                on-title-click={() => {
                                    if (headerSortable) this.sortHeaderColumn(column, item.EDCSS)
                                }}
                                on-query={this.qryTabData}
                            />,
                            renderBodyCell: ({row}) => {
                                const value = row[item.key]
                                if (item.key === 'IDNO') return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{value}</div></el-link>
                                if (item.key === 'STFG') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : value === 'N' ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> : <span>{value}</span>
                                if (item.key === 'ISSTK') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : value === 'N' ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> : <span>{value}</span>
                                return <span>{value}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        renderHeaderCell: () => <el-link underline={false} on-click={() => this.rowShow()} style="font-size:12px;color:#404eff"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 215,
                        align: 'center',
                        fixed: 'right',
                        renderBodyCell: ({row, rowIndex}) => (
                            <div style="white-space:nowrap">
                                <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:3px"></i>
                                <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.cfmBool} on-click={() => this.recSet(row, 'Y')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.delBool} on-click={() => this.recSet(row, 'X')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0131', '删除')}</span></el-link></span> : null}
                                {row.STFG === 'Y' ? <span> <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.cfmBool} on-click={() => this.recSet(row, 'N')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link></span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401217','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401217','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        min-width:200px;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    #po_send_main_table .ve-table-content-wrapper {
        min-height: 100%;
    }
    #po_send_main_table .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    #po_send_main_table .table-body-cell-class1 {
        height: 20px !important;
        padding: 2px !important;
        color: black !important;
        font-size: 12px !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    #po_send_main_table .ve-table-header-th[fixed="right"],
    #po_send_main_table .ve-table-body-td[fixed="right"] {
        white-space: nowrap;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
 
    .el-drawer__header{
        padding: 0px;
    }
 
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
